import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLayoutTdl = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 18,
	viewBox: "0 0 21 18",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsxs("text", {
			fill: "#4A5666",
			fontFamily: "Lato-Regular, Lato",
			fontSize: 12,
			letterSpacing: -.5,
			transform: "translate(0 -3)",
			children: [/* @__PURE__ */ _jsx("tspan", {
				x: 0,
				y: 12,
				children: "TD"
			}), /* @__PURE__ */ _jsx("tspan", {
				x: 15.116,
				y: 12,
				children: "L"
			})]
		}), /* @__PURE__ */ _jsxs("g", {
			stroke: "#4A5666",
			children: [/* @__PURE__ */ _jsx("path", {
				strokeLinecap: "square",
				strokeWidth: 1.5,
				d: "M7.071 14.607h10"
			}), /* @__PURE__ */ _jsx("path", {
				fill: "#4A5666",
				strokeWidth: 2,
				d: "m18.642 14.607-3 1.5v-3zM2.571 14.607l3-1.5v3z"
			})]
		})]
	})
});
export default SvgLayoutTdl;
